import { UuidProjectType } from 'core/userContext';
import { LookupType } from '../types';

/**
 * Generates an array of available lookup types based on the project type
 * and feature flag status.
 *
 * For Non-UUID non-UserID projects: [Email]
 * For Non-UUID UserID projects: [Email, User ID]
 * For UUID email-unique projects: [Email, User ID]
 * For UUID email-non-unique projects: [User ID]
 */
export const getAvailableLookupTypes = (
  isUuidProject: boolean,
  uuidProjectType: UuidProjectType,
  isLegacyUserIdProject: boolean,
) => {
  const availableLookupTypes = [];

  if (!isUuidProject || uuidProjectType === UuidProjectType.EmailUnique) {
    availableLookupTypes.push(LookupType.ByEmail);
  }

  if (isUuidProject || isLegacyUserIdProject) {
    availableLookupTypes.push(LookupType.ByUserId);
  }

  return availableLookupTypes;
};
